module.exports = __webpack_public_path__ + "static/media/BC_Timeless_Piazza_DK Grey.078aee95.png";